import React, {useContext} from 'react';
import SettingsForm from "./SettingsForm";
import authContext from "../../AuthProvider/authContext";

const Settings = () => {
    const {state} = useContext(authContext);
    const user = state.auth;

    return (
        <div className="Settings-content">
            <SettingsForm user={user}/>
        </div>
    );
};

export default Settings;